// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"LoadingOverlay_loadingContainer__gMZq7","spinner":"LoadingOverlay_spinner__ChlDz","spinnerLoading":"LoadingOverlay_spinnerLoading__bmkyB"};